export default __webpack_public_path__ + "static/media/Horizontal2.43915065.jpeg";